/** @internal */
export const TableName = Symbol.for('drizzle:Name');
